import Organizations from '../views/layouts/Organizations.jsx';
import View from '../views/layouts/OrganizationView/index.js';
import Edit from '../views/layouts/OrganizationForm/containers/Edit.js';
import Create from '../views/layouts/OrganizationForm/containers/Create.js';

import NotFound from '../views/common/StatusCodes.jsx';

import requireAuth from '~/views/enhancers/requireAuth.jsx';
import SubRoutes from './components/SubRoutes.jsx';


const ROOT_PATH = '/nh/organizations';

export default [
    {
        path: ROOT_PATH,
        exact: true,
        component: requireAuth(Organizations),
    },
    {
        path: `${ROOT_PATH}/create`,
        exact: true,
        component: requireAuth(Create),
    },
    {
        path: `${ROOT_PATH}/:id`,
        component: requireAuth(SubRoutes),
        routes: [
            {
                path: `${ROOT_PATH}/:id`,
                exact: true,
                component: View,
            },
            {
                path: `${ROOT_PATH}/:id/edit`,
                exact: true,
                component: Edit,
            },
            {
                path: '*', component: NotFound,
            },
        ],
    },
];
